import { Nullable } from './Nullable';

export enum OfferMessageType {
    SEND_OFFER,
}

export type OfferMessage = {
    id: string
    type: OfferMessageType
    offer: {
        id: string
    }
    org: {
        id: string
    }
    includePdf: boolean
    text: Nullable<string>
}
